import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Quote } from 'lucide-react';
import { stories } from '../data/stories';
const categoryLabels: Record<string, string> = {
  all: 'Alles',
  general: 'De Maekerij',
  workshop: 'Workshops',
  maekerscafe: 'Maekerscafés'
};
export function Verhalen() {
  const [activeFilter, setActiveFilter] = useState<string>('all');
  const filtered = activeFilter === 'all' ? stories : stories.filter(s => s.category === activeFilter);
  const storiesWithFull = filtered.filter(s => s.slug && s.fullStory);
  const shortQuotes = filtered.filter(s => !s.fullStory);
  return <div className="container mx-auto px-4 py-12" data-id="element-1276">
      <div className="max-w-4xl mx-auto" data-id="element-1277">
        <div className="text-center mb-8" data-id="element-1278">
          <h1 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-1279">Verhalen</h1>
          <p className="text-xl text-gray-600" data-id="element-1280">
            Echte verhalen van vrouwen die De Maekerij ontdekten
          </p>
        </div>

        {/* Filter labels */}
        <div className="flex flex-wrap justify-center gap-2 mb-12" data-id="element-1281">
          {Object.entries(categoryLabels).map(([key, label]) => <button key={key} onClick={() => setActiveFilter(key)} className={`px-4 py-1.5 rounded-full text-sm font-medium border transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-gray-300 ${activeFilter === key ? 'bg-gray-800 text-white border-gray-800' : 'bg-white text-gray-600 border-gray-300 hover:border-gray-400 hover:bg-gray-50'}`} data-id="element-1282">
              {label}
            </button>)}
        </div>

        {storiesWithFull.length > 0 && <div className="space-y-8" data-id="element-1283">
            {storiesWithFull.map(story => <Link key={story.slug} to={`/verhalen/${story.slug}`} className="block group" data-id="element-1284">
                <div className="border border-gray-200 rounded-lg p-8 bg-white hover:border-gray-300 transition-colors duration-150" data-id="element-1285">
                  <div className="flex flex-col md:flex-row gap-6" data-id="element-1286">
                    <div className="md:w-1/4 flex-shrink-0" data-id="element-1287">
                      <div className="border-2 border-dashed border-gray-300 h-40 md:h-full flex items-center justify-center bg-gray-100 rounded-lg" data-id="element-1288">
                        <span className="text-gray-400 text-sm" data-id="element-1289">
                          Foto {story.name}
                        </span>
                      </div>
                    </div>
                    <div className="md:w-3/4" data-id="element-1290">
                      <div className="flex items-center gap-2 mb-2" data-id="element-1291">
                        <Quote size={18} className="text-gray-300" data-id="element-1292" />
                        <span className="text-[10px] uppercase tracking-wider font-medium text-gray-400 border border-gray-200 rounded px-1.5 py-0.5" data-id="element-1293">
                          {categoryLabels[story.category] || story.category}
                        </span>
                      </div>
                      <p className="text-gray-700 leading-relaxed italic mb-4" data-id="element-1294">
                        "{story.quote}"
                      </p>
                      <div className="flex items-center mb-4" data-id="element-1295">
                        <div className="border border-dashed border-gray-300 w-10 h-10 rounded-full flex items-center justify-center bg-gray-100 mr-3 flex-shrink-0" data-id="element-1296">
                          <span className="text-gray-400 text-xs font-medium" data-id="element-1297">
                            {story.name.charAt(0)}
                          </span>
                        </div>
                        <div data-id="element-1298">
                          <p className="text-sm font-medium text-gray-900" data-id="element-1299">
                            {story.name}
                          </p>
                          <p className="text-xs text-gray-500" data-id="element-1300">
                            {story.context}
                          </p>
                        </div>
                      </div>
                      <span className="text-sm font-medium text-gray-600 group-hover:text-gray-900 inline-flex items-center" data-id="element-1301">
                        Lees het volledige verhaal
                        <ArrowRight size={14} className="ml-1 group-hover:translate-x-1 transition-transform duration-200" data-id="element-1302" />
                      </span>
                    </div>
                  </div>
                </div>
              </Link>)}
          </div>}

        {/* All quotes grid */}
        {shortQuotes.length > 0 && <div className={storiesWithFull.length > 0 ? 'mt-16' : ''} data-id="element-1303">
            <h2 className="text-xl font-bold mb-6" data-id="element-1304">
              Meer stemmen uit De Maekerij
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1305">
              {shortQuotes.map((story, i) => <div key={i} className="border border-gray-200 rounded-lg p-5 bg-white" data-id="element-1306">
                  <div className="flex items-center gap-2 mb-2" data-id="element-1307">
                    <span className="text-[10px] uppercase tracking-wider font-medium text-gray-400 border border-gray-200 rounded px-1.5 py-0.5" data-id="element-1308">
                      {categoryLabels[story.category] || story.category}
                    </span>
                  </div>
                  <p className="text-sm text-gray-700 leading-relaxed italic mb-3" data-id="element-1309">
                    "{story.quote}"
                  </p>
                  <div className="flex items-center" data-id="element-1310">
                    <div className="border border-dashed border-gray-300 w-8 h-8 rounded-full flex items-center justify-center bg-gray-100 mr-2 flex-shrink-0" data-id="element-1311">
                      <span className="text-gray-400 text-[10px] font-medium" data-id="element-1312">
                        {story.name.charAt(0)}
                      </span>
                    </div>
                    <div data-id="element-1313">
                      <p className="text-xs font-medium text-gray-900" data-id="element-1314">
                        {story.name}
                      </p>
                      <p className="text-[10px] text-gray-500" data-id="element-1315">
                        {story.context}
                      </p>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>}

        {storiesWithFull.length === 0 && shortQuotes.length === 0 && <div className="text-center py-12 text-gray-400" data-id="element-1316">
            Geen verhalen gevonden voor dit filter.
          </div>}
      </div>
    </div>;
}